import React from 'react';
import { Provider } from 'react-redux';
import { RelayEnvironmentProvider } from 'react-relay';

import AccessContainer from './components/AccessContainer';
import { IGant } from './gant/gant';
import GantCalendarLoader from './gant/gantCalendarLoader';
import GantWrapper from './gant/gantWrapper';
import { store } from './store';

const outGant: React.FC<IGant> = ({ paddingBottom, environment, onFinishLoadData, authorId, mode, ...restProps }) => {
    const gantComponent = (
        <AccessContainer accessFor={['work-item.view']} isAlert>
            <GantCalendarLoader onFinishLoadData={onFinishLoadData} authorId={authorId} />

            <GantWrapper paddingBottom={paddingBottom} authorId={authorId} mode={mode} {...restProps} />
        </AccessContainer>
    );

    return (
        <Provider store={store}>
            {environment ? (
                <RelayEnvironmentProvider environment={environment}>{gantComponent}</RelayEnvironmentProvider>
            ) : (
                gantComponent
            )}
        </Provider>
    );
};

export default outGant;
